import React from "react";
import logo from "../Static/logo.svg";
import "../Static/LandingV2.css";

export default function Navbar() {
  return (
    <header className="cc-nav">
      <div className="cc-navInner">
        <a className="cc-brand" href="#top">
          <img src={logo} alt="CodeCarbon logo" className="cc-brandLogo" />
          <span className="cc-brandText">CodeCarbon</span>
        </a>

        <nav className="cc-navLinks">
          <a href="#products">Products</a>
          <a href="#capabilities">Capabilities</a>
          <a href="mailto:support@codecarbonhq.com" className="cc-navCta">
            Contact
          </a>
        </nav>
      </div>
    </header>
  );
}
